import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaStar, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./testimonial.css";
import testimonialImg from "../../assets/testimonial-mainimage.png"; // right-side illustration

function Testimonial() {
  // ✅ Testimonials Data
  const testimonials = [
    {
      id: 1,
      name: "Sarah L.",
      role: "Marketing Manager",
      text: "Redite redesigned our website and helped us improve our SEO. We've seen more traffic and better engagement. Highly recommend!",
      img: "https://i.pravatar.cc/100?img=1",
    },
    {
      id: 2,
      name: "John D.",
      role: "Business Owner",
      text: "The Redite team did an excellent job modernizing our CRM system. Their attention to detail and quick turnaround impressed us.",
      img: "https://i.pravatar.cc/100?img=2",
    },
    {
      id: 3,
      name: "Priya S.",
      role: "Project Coordinator",
      text: "Their software automation tools saved us hours every week. Great communication and on-time delivery!",
      img: "https://i.pravatar.cc/100?img=3",
    },
    {
      id: 4,
      name: "Michael R.",
      role: "Operations Head",
      text: "We saw a huge improvement in workflow after using their management software. Highly efficient and user-friendly design.",
      img: "https://i.pravatar.cc/100?img=4",
    },
    {
      id: 5,
      name: "Nisha K.",
      role: "Creative Director",
      text: "Amazing support team! They helped us launch our website successfully and provided all the training we needed.",
      img: "https://i.pravatar.cc/100?img=5",
    },
    {
      id: 6,
      name: "David P.",
      role: "Sales Manager",
      text: "Their web redesign increased our client inquiries by 40%. Very professional and easy to work with.",
      img: "https://i.pravatar.cc/100?img=6",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);

  // ✅ Navigation functions
  const handlePrev = () => {
    setDirection(-1);
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setDirection(1);
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const { name, role, text, img } = testimonials[currentIndex];

  // ✅ Framer Motion variants for slider
  const variants = {
    enter: (direction) => ({
      x: direction > 0 ? 100 : -100,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
    exit: (direction) => ({
      x: direction > 0 ? -100 : 100,
      opacity: 0,
      transition: { duration: 0.6, ease: "easeIn" },
    }),
  };

  // ✅ Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      offset: 120,
      mirror: false,
    });
  }, []);

  return (
    <section className="testimonial-section">
      <div className="testimonial-container">
        {/* ✅ Left Side - Text */}
        <div className="testimonial-left" data-aos="fade-right">
          <h5 className="testimonial-subtitle">TESTIMONIALS</h5>
          <h2 className="testimonial-title">What Our Clients Say</h2>

          <div className="testimonial-stars">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} color="#f5b50a" />
            ))}
          </div>

          <div className="testimonial-slider">
            <AnimatePresence custom={direction}>
              <motion.div
                key={currentIndex}
                custom={direction}
                variants={variants}
                initial="enter"
                animate="center"
                exit="exit"
                className="testimonial-content"
              >
                <p className="testimonial-text">{text}</p>

                <div className="testimonial-user">
                  <img src={img} alt={name} className="testimonial-user-img" />
                  <div>
                    <h4 className="testimonial-user-name" style={{ color: "#e00c09" }}>
                      {name}
                    </h4>
                    <p className="testimonial-user-role">{role}</p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* ✅ Arrows */}
          <div className="testimonial-arrows">
            <FaArrowLeft className="arrow" onClick={handlePrev} />
            <FaArrowRight className="arrow" onClick={handleNext} />
          </div>
        </div>

        {/* ✅ Right Side - Illustration */}
        <div className="testimonial-right" data-aos="fade-left">
          <img
            src={testimonialImg}
            alt="Client Illustration"
            className="testimonial-illustration"
          />
        </div>
      </div>
    </section>
  );
}

export default Testimonial;
